/* eslint-disable */
import { useEffect, useState } from 'react';
import { server } from '../constants';
import { useRecoilState, atom } from 'recoil';

export { useApprove };

const baseApi = 'approve';

const filterStatusAtom = atom({
  key: `${baseApi}filterStatusAtom`,
  default: 'A'
});

const filterPlantAtom = atom({
  key: `${baseApi}filterPlantAtom`,
  default: '%'
});

function useApprove() {
  const [filterPlant, setFilterPlant] = useRecoilState(filterPlantAtom);
  const [filterStatus, setFilterStatus] = useRecoilState(filterStatusAtom);

  return {
    filterPlant,
    setFilterPlant,
    filterStatus,
    setFilterStatus
  };
}
